import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import i18n from '../i18n';
import { DEFAULT_LANGUAGE, SupportedLanguage } from '../i18n/resources';
import { trackAnalyticsEvent } from '../services/analytics';

interface PreferencesState {
  language: SupportedLanguage;
  setLanguage: (lang: SupportedLanguage) => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  devtools(
    persist(
      (set, get) => ({
        language: DEFAULT_LANGUAGE,
        setLanguage: (lang: SupportedLanguage) => {
          const previous = get().language;
          if (previous === lang) return;
          set({ language: lang }, false, 'setLanguage');
          void i18n.changeLanguage(lang);
          trackAnalyticsEvent('language_changed', {
            from: previous,
            to: lang,
            timestamp: new Date().toISOString(),
          });
        },
      }),
      {
        name: 'atlas-preferences',
        partialize: (state) => ({ language: state.language }),
      }
    ),
    { name: 'PreferencesStore' }
  )
);

export const useLanguage = () => usePreferencesStore((s) => s.language);
